import { toast } from 'react-toastify';
import React from 'react';

function successToast(text, delay = 3000) {
  toast.dismiss();
  toast.success(
    <h1>
      {text}
    </h1>, {
      autoClose: delay,
      closeButton: false,
    },
  );
}

function errorToast(msg, options, delay = 5000) {
  toast.dismiss();
  toast.error(
    <h1 {...options}>
      {msg || 'Sorry, an unknown error occurred. Please try again later.'}
    </h1>, {
      autoClose: delay,
    },
  );
}

export { successToast, errorToast };
